export default __webpack_public_path__ + "static/media/zillow.75970dc0.png";